/**
 * Unwinder mirror of the opener's `needsOpenerAutoEnable` (entry/activationGate.ts).
 *
 * Arming an unwinder leg (platform toggle ON) triggers rule activation, which
 * the backend refuses with a 400 (`assertPairUnwinderEnabled`: "Pair is turned
 * OFF for the unwinder") when the pair's `unwinderEnabled` is false. Without an
 * auto-enable the optimistic toggle flips ON, the `toggle-platform` PATCH 400s,
 * `onError` rolls it back, and the switch snaps back to OFF (looks like it
 * never took, persisting after reload).
 *
 * The unwinder's persisted kill switch is surfaced to the FE only via the live
 * (`unwinding_state*`) envelope's `unwinderEnabled` — the REST
 * `/positions/grouped` payload does not carry it — so the decision reads that.
 * The backend still emits an envelope (with `unwinderEnabled: false`) for a
 * pair the operator turned off, so this reliably detects the real "off" case.
 * Default is true, so an unknown (undefined) value needs no auto-enable.
 */
export function needsUnwinderAutoEnable(
  group: { _id?: string | null },
  unwinderEnabled: boolean | undefined,
  arming: boolean
): boolean {
  return arming && !!group._id && unwinderEnabled === false;
}
